export default __webpack_public_path__ + "static/media/join_community_organisme.f99e559f.png";